import axios from "axios";

export function isUnique(name, credentialState) {
  const trimmedName = name.trim();
  // validate name is unique
  if (credentialState != null) {
    for (let i = 0; i < credentialState.length; i++) {
      if (trimmedName === credentialState[i].name) {
        return false;
      }
    }
  }
  return true;
}

export function isLengthValid(name, credentialState) {
  const trimmedName = name.trim();
  // validate name length
  if (trimmedName === "" || trimmedName.length < 3 || trimmedName.length > 64) {
    return false;
  }
  return true;
}

export function isScopeValid(sid) {
  // validate integer
  if (!/^[0-9]+$/.test(sid)) {
    return false;
  }
  return true;
}

//for use by react-query
export const requestPost = (options) => {
  const onSuccess = (response) => response;
  const onError = (error) => {
    throw error;
  };
  return axios
    .post(options.url, null, { ...options })
    .then(onSuccess)
    .catch(onError);
};

export const requestGet = (options) => {
  const onSuccess = (response) => response;
  const onError = (error) => {
    throw error;
  };
  return axios
    .get(options.url, { ...options })
    .then(onSuccess)
    .catch(onError);
};
